(function () {
  function forceOnePerView(container) {
    // 1) If Swiper exists, override params
    var sw = container && container.swiper;
    if (sw) {
      sw.params.slidesPerView = 1;
      sw.params.slidesPerGroup = 1;
      sw.params.centeredSlides = false;
      sw.params.spaceBetween = 0;

      if (sw.params.breakpoints) {
        Object.keys(sw.params.breakpoints).forEach(function (bp) {
          var o = sw.params.breakpoints[bp] || {};
          o.slidesPerView = 1;
          o.slidesPerGroup = 1;
          o.centeredSlides = false;
          o.spaceBetween = 0;
          sw.params.breakpoints[bp] = o;
        });
      }

      // 2) Hard-set each slide’s width so Swiper can’t auto-pack
      var slides = container.querySelectorAll('.swiper-slide');
      slides.forEach(function (s) {
        s.style.width = '100%';
        s.style.flex = '0 0 100%';
        s.style.maxWidth = '100%';
      });

      // 3) Recalculate
      sw.updateSlides();
      sw.update();
      return true;
    }
    return false;
  }

  function recreateIfNeeded(container) {
    // If the theme initialized with incompatible options, re-init cleanly
    if (!container) return;
    var sw = container.swiper;
    if (!sw) return;

    var SwiperCtor = window.Swiper || (window && window.default && window.default.Swiper);
    if (!SwiperCtor) return; // Swiper not on window

    // If still not 1 per view, rebuild
    var wrong =
      sw.params.slidesPerView !== 1 ||
      (sw.params.breakpoints && Object.values(sw.params.breakpoints).some(function (bp) { return bp && bp.slidesPerView !== 1; }));

    if (wrong) {
      var opts = Object.assign({}, sw.params);
      opts.slidesPerView = 1;
      opts.slidesPerGroup = 1;
      opts.centeredSlides = false;
      opts.spaceBetween = 0;
      opts.breakpoints = {}; // wipe breakpoints
      sw.destroy(true, true);
      new SwiperCtor(container, opts);
      // Reapply width lock after recreate
      forceOnePerView(container);
    }
  }

  function ensure(container) {
    if (!container) return;
    // Try immediately…
    if (forceOnePerView(container)) {
      recreateIfNeeded(container);
      return;
    }
    // …or wait for Swiper to attach
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (forceOnePerView(container)) {
        recreateIfNeeded(container);
        clearInterval(iv);
      }
      if (tries > 20) clearInterval(iv); // ~2s cap
    }, 100);
  }

  function run(scope) {
    (scope || document).querySelectorAll('.product-area--carousel .theme-viewport.swiper-container')
      .forEach(function (el) { ensure(el); });
  }

  // Initial runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ run(document); });
  } else {
    run(document);
  }
  window.addEventListener('load', function(){ run(document); });

  // Re-run on Shopify section reloads / dynamic updates
  document.addEventListener('shopify:section:load', function (e) { run(e.target || document); });
  document.addEventListener('variant:change', function () { run(document); });

  // MutationObserver fallback (in case theme injects later)
  var mo = new MutationObserver(function (muts) {
    for (var i=0;i<muts.length;i++) {
      var t = muts[i].target;
      if (t && t.querySelector && t.querySelector('.product-area--carousel .theme-viewport.swiper-container')) {
        run(t);
        break;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

